module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-RegularItalic.cc3bab00.woff";